// extracted by mini-css-extract-plugin
export var message = "popUp-module--message--a219a";
export var wrapper = "popUp-module--wrapper--526d0";